import { GlobalAxios } from "../axios/axios-config";
import { ISyncPersonDetails } from "../models/sync-person";

const SYNC_PERSON_DETAILS_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/SyncPerson/SyncPersonDetails";

export const getSyncPersonDetails = ({ identifier }: { identifier: number }) => {
  return GlobalAxios.get<ISyncPersonDetails>(SYNC_PERSON_DETAILS_ROUTE, {
    params: { Identifier: identifier },
  });
};
